// Note: The first file of a module here, must also register the module

import "./data-set-anonymize-dialog.component";
